module.exports = __webpack_public_path__ + "static/media/intro-en-ru.fbe5420f.vtt";